const u = {
  local: {
    searchBaseUrl: "https://dev-nol.yanolja.com/discovery",
    smartDiscoveryApiUrl: "https://dev-smart-discovery-api.yanolja.com"
  },
  dev: {
    searchBaseUrl: "https://dev-nol.yanolja.com/discovery",
    smartDiscoveryApiUrl: "https://dev-smart-discovery-api.yanolja.com"
  },
  qa: {
    searchBaseUrl: "https://qa-nol.yanolja.com/discovery",
    smartDiscoveryApiUrl: "https://qa-smart-discovery-api.yanolja.com"
  },
  stage: {
    searchBaseUrl: "https://stage-nol.yanolja.com/discovery",
    smartDiscoveryApiUrl: "https://stage-smart-discovery-api.yanolja.com"
  },
  prod: {
    searchBaseUrl: "https://nol.yanolja.com/discovery",
    smartDiscoveryApiUrl: "https://smart-discovery-api.yanolja.com"
  }
}, h = 2500, I = (e, a, t) => {
  const s = e.replace(/\/+$/, ""), r = new URL(`${s}${a}`);
  return t && Object.entries(t).forEach(([l, c]) => {
    c && r.searchParams.set(l, c);
  }), r.toString();
}, d = (e) => {
  const a = async (t, s, r, l = !1) => {
    var _;
    const c = new AbortController(), o = (r == null ? void 0 : r.timeout) ?? h, E = setTimeout(() => {
      c.abort("timeout");
    }, o);
    (_ = r == null ? void 0 : r.signal) == null || _.addEventListener("abort", () => c.abort());
    try {
      const T = I(e, s, r == null ? void 0 : r.params), n = await fetch(T, {
        method: t,
        headers: { ...r == null ? void 0 : r.headers },
        body: r != null && r.body ? JSON.stringify(r.body) : void 0,
        signal: c.signal,
        credentials: "include",
        cache: "no-cache"
      });
      if (!n.ok)
        throw new i(n, `[fetcher] ${t} ${s} failed: ${n.status}`, {
          ...r,
          method: t,
          path: s
        });
      return n.json();
    } catch (T) {
      if (T instanceof Error && T.name === "AbortError") {
        if (c.signal.reason === "timeout" && l)
          return a(t, s, r, !1);
        throw new Error(`Request timeout: ${h}ms`);
      }
      throw T;
    } finally {
      clearTimeout(E);
    }
  };
  return {
    get: (t, s) => a("GET", t, s),
    post: (t, s, r) => a("POST", t, { ...r, body: s }),
    delete: (t, s) => a("DELETE", t, s)
  };
};
class i extends Error {
  constructor(a, t, s) {
    super(t), this.name = "FetchError", this.errorInfo = a, this.request = s;
  }
}
const v = (e, a) => {
  const t = d(e);
  return { fetchSearchHome: (o, E) => t.get("/search/v1/home", {
    params: o,
    headers: { ...a, ...E }
  }), fetchAutocomplete: (o, E, _) => t.post("/autocomplete/v1", o, {
    headers: { ...a, ...E },
    signal: _,
    timeout: 1500
  }), saveKeyword: (o, E) => t.post("/interest/v1/keyword", o, {
    headers: { ...a, ...E }
  }), deleteKeyword: (o, E) => t.delete("/interest/v1/keyword", {
    params: o,
    headers: { ...a, ...E }
  }) };
};
var P = /* @__PURE__ */ ((e) => (e.ITEM_TYPE_UNSPECIFIED = "ITEM_TYPE_UNSPECIFIED", e.ITEM_TYPE_USER_QUERY = "ITEM_TYPE_USER_QUERY", e.ITEM_TYPE_PRODUCT = "ITEM_TYPE_PRODUCT", e.ITEM_TYPE_POI = "ITEM_TYPE_POI", e.ITEM_TYPE_REGION = "ITEM_TYPE_REGION", e.ITEM_TYPE_STATION = "ITEM_TYPE_STATION", e.ITEM_TYPE_AIRPORT = "ITEM_TYPE_AIRPORT", e.ITEM_TYPE_LEISURE_THEME = "ITEM_TYPE_LEISURE_THEME", e.ITEM_TYPE_ONSITE_MARKETING = "ITEM_TYPE_ONSITE_MARKETING", e.ITEM_TYPE_ARTIST = "ITEM_TYPE_ARTIST", e.ITEM_TYPE_CID = "ITEM_TYPE_CID", e.UNRECOGNIZED = "UNRECOGNIZED", e))(P || {});
export {
  P as I,
  u as a,
  v as c
};
